import { jsx, jsxs } from "react/jsx-runtime";
import { inputSelectVariants } from "./InputSelect.variants.js";
import { Select } from "../Select/index.js";
import { useState } from "react";
function InputSelect({ labelText, options, name, defaultValue = options[0]?.value ?? '', onChange, size, isAutoWidth = false, selectMinWidth, selectPadding, ...restProps }) {
    const { root, labelSlot } = inputSelectVariants({
        size
    });
    const [currentValue, setCurrentValue] = useState(defaultValue);
    const selectedOption = options.find((option)=>option.value === currentValue) || options[0] || {
        value: '',
        label: ''
    };
    const menuItems = options.map((option)=>({
            label: String(option.label),
            value: String(option.value)
        }));
    const handleChange = (value)=>{
        const numericValue = isNaN(Number(value)) ? value : Number(value);
        setCurrentValue(numericValue);
        const selectEvent = {
            target: {
                value: numericValue,
                name
            }
        };
        onChange(selectEvent);
    };
    return /*#__PURE__*/ jsxs("div", {
        className: root(),
        "data-testid": "input-select-component",
        children: [
            labelText ? /*#__PURE__*/ jsx("label", {
                htmlFor: name,
                className: labelSlot(),
                children: labelText
            }) : null,
            /*#__PURE__*/ jsx(Select, {
                selectPadding: selectPadding,
                selectMinWidth: selectMinWidth,
                label: labelText || '',
                isLabelHidden: true,
                menuItems: menuItems,
                placeholder: String(selectedOption?.label || ''),
                initialValue: String(currentValue),
                onChange: handleChange,
                size: size,
                isAutoWidth: isAutoWidth,
                ...restProps
            })
        ]
    });
}
export { InputSelect };
